import { ProcurementSendVendorOnboardingInvitationDocument } from 'generated/resources/graphql'

import { InlineEmailMessageForm } from 'modules/core/components/InlineEmailMessageForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

const useSendVendorOnboardingInvitation = () =>
  useMutation(ProcurementSendVendorOnboardingInvitationDocument, {
    extractorFn: (data) =>
      data.vendorPortalMutations.sendInvitationVendorportalVendorOnboardingInvitation,
  })

interface SendToVendorInlineFormProps {
  taskableId: string
  onSuccess?: () => void
  onError?: () => void
  vendorEmail?: string
  vendorMessage?: string
  disabled?: boolean
}

export const SendToVendorInlineForm = ({
  taskableId,
  onSuccess,
  onError,
  vendorEmail,
  vendorMessage,
  disabled = false,
}: SendToVendorInlineFormProps) => {
  const [sendVendorOnboardingInvitation] = useSendVendorOnboardingInvitation()

  return (
    <InlineEmailMessageForm
      name="send-to-vendor-inline"
      defaultEmail={vendorEmail}
      defaultMessage={vendorMessage}
      emailLabel={i18n.t('tasks.types.vendor_onboarding.send_to_vendor.email_label')}
      emailPlaceholder={i18n.t('tasks.types.vendor_onboarding.send_to_vendor.email_placeholder')}
      messageLabel={i18n.t('tasks.types.vendor_onboarding.send_to_vendor.message_label')}
      messagePlaceholder={i18n.t(
        'tasks.types.vendor_onboarding.send_to_vendor.message_placeholder'
      )}
      submitLabel={i18n.t('tasks.types.vendor_onboarding.send_to_vendor.submit')}
      disabled={disabled}
      onSubmit={async ({ email, message }) => {
        const result = await sendVendorOnboardingInvitation({
          variables: {
            vendorOnboardingTaskId: taskableId,
            vendorEmail: email,
            vendorMessage: message || undefined,
          },
        })
        const handled = handleResult(result, () => {})

        if (!handled.success) {
          onError?.()

          return {
            success: false,
            errors: {},
          }
        }

        onSuccess?.()
        return { success: true }
      }}
    />
  )
}
